import React, {createContext, useContext, useState} from 'react'

const AccountEditContext = createContext()

export const AccountEditProvider = ({children}) => {
    const [isEditing, setIsEditing] = useState(false)
    const [isDirty, setIsDirty] = useState(false)

    const startEditing = () => setIsEditing(true)
    const stopEditing = () => {
        setIsEditing(false)
        setIsDirty(false)
    }
    const setFormDirty = (dirty) => setIsDirty(dirty)

    return (
        <AccountEditContext.Provider value={{isEditing, isDirty, startEditing, stopEditing, setFormDirty}}>
            {children}
        </AccountEditContext.Provider>
    )
}

export const useAccountEdit = () => useContext(AccountEditContext)
